import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import Topbar from "../../components/topbar/Topbar";

import Sidebar from "../../components/sidebar/Sidebar";
import { useState, useEffect } from "react";
import style from "./Notificacoes.module.css";
import NotificacaoApi from "../../services/NotificacaoApi";
import { Link } from "react-router-dom";
import { IoIosNotifications } from "react-icons/io";
import { useLocation } from "react-router-dom";

function Notificacoes() {
  //Para abrir e fechar o menu hamburguer
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(false);

  const location = useLocation();
  const [notificacaoId, setNotificacaoId] = useState(location.state ?? null);
  const [loading, setLoading] = useState(false);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 10000);
  };

  const [notificacoes, setNotificacoes] = useState([]);

  async function mostrarNotificacoes() {
    try {
      const notificacao =
        await NotificacaoApi.ListarNotificacoesPorUsuarioIdAsync();
      setNotificacoes(notificacao);
    } catch (error) {
      console.error(
        "Erro ao listar notificações:",
        error?.response?.data || error.message
      );
    }
  }

  async function marcarComoLidoNotificacao(notificacao) {
    try {
      setNotificacaoId(notificacao.notificacaoId);
      if (!notificacao.lido) {
        await NotificacaoApi.MarcarNotificacaoComoLidoAsync(
          notificacao.notificacaoId
        );
        await mostrarNotificacoes();
      }
    } catch (error) {
      console.error(
        "Erro ao marcar notificação como lido:",
        error.response.data
      );
    }
  }

  useEffect(() => {
    mostrarNotificacoes();
  }, []);

  const notificacaoSelecionada = notificacoes.find(
    (n) => n.notificacaoId === notificacaoId
  );

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}

        <div className={style.pagina_conteudo}>
          <h2 className={style.primeiro_titulo}>Notificações</h2>

          <div className={style.notificacao}>
            <div className={style.container_lista_notificacoes}>
              {notificacoes.map((notificacao) => (
                <Link
                  onClick={() => marcarComoLidoNotificacao(notificacao)}
                  key={notificacao.notificacaoId}
                  className={`${style.container_notificacao} ${
                    !notificacao.lido ? style.notificacaoLida : ""
                  } ${
                    notificacaoId === notificacao.notificacaoId
                      ? style.notificacaoSelecionada
                      : ""
                  }`}
                >
                  <div className={style.conteudo_notificacao}>
                    <IoIosNotifications id={style.icone_notificacao} />
                    <h6 id={style.titulo_notificacao}>{notificacao.titulo}</h6>
                  </div>
                  <div className={style.corpo_notificacao}>
                    <p>
                      {new Date(notificacao.dataEnvio).toLocaleString("pt-BR")}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
            <div className={style.container_corpo_notificacao}>
              {notificacaoSelecionada ? (
                <>
                  <div className={style.notificacao_header}>
                    <h5>{notificacaoSelecionada.titulo}</h5>
                  </div>
                  <div className={style.notificacao_body}>
                    <p>{notificacaoSelecionada.descricao}</p>
                  </div>
                  <div className={style.notificacao_footer}>
                    <p>
                      {new Date(
                        notificacaoSelecionada.dataEnvio
                      ).toLocaleString("pt-BR")}
                    </p>
                  </div>
                </>
              ) : (
                <h6 className={style.mensagem_selecione_notificacao}>
                  Selecione uma notificação para visualizar os detalhes.
                </h6>
              )}
            </div>
          </div>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default Notificacoes;
